module.exports = __webpack_public_path__ + "static/assassin-dagger-b9a5e2e16dcc325b737f9900998836d5.png";